<template>
  <v-container fluid>
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :item-class="rowClass"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #[`item.asm_pavadinimas`]="{ item }">
        {{ item.asm_pavadinimas }}
        <span v-if="item.yra_mires" class="text-gray">(asmuo miręs)</span>

        <div v-if="item.isAtstovas" class="text-gray">
          <v-divider />
          <v-row dense no-gutters>
            <v-col cols="12" md="12">
              <span class="text-gray">Atstovas:</span>
            </v-col>
            <v-col cols="12" md="12">
              <span class="text-gray">{{ item.atstovas_pavadinimas }}</span>
            </v-col>
            <v-col cols="12" md="12">
              <span
                class="text-gray"
                v-html="item.atstovas_veikiantis_nowrap"
              ></span>
            </v-col>
          </v-row>
        </div>
      </template>
      <template #[`item.sasm_el_pastai`]="{ item }">
        {{ item.sasm_el_pastai.join(', ') }}
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item"
          @editItem="editItem(item)"
          @viewItem="editItem(item)"
        />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-prasymas-informavimas
      :key="modalInformavimasKey"
      v-model="showInformavimas"
      :item="modalInformavimasItem"
      :readonly="modalInformavimasReadonly"
      @confirmSave="confirmInformavimas"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import checkErrors from '@/mixins/checkErrors'
import ModalPrasymasInformavimas from '../modals/ModalPrasymasInformavimas'
import rowClass from '@/mixins/rowClass'
import busena from '@/mixins/busenaNtr'
import userRole from '@/mixins/userRole'

export default {
  name: 'RegPrasymasInformavimasAsmenys',
  components: {
    ModalPrasymasInformavimas,
  },
  props: {
    readonlyForm: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  mixins: [busena, rowClass, userRole, checkErrors],
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      showAsmuo: false,
      modalInformavimasItem: {},
      modalInformavimasReadonly: false,
      modalInformavimasKey: 'informavimas',
      modalInformavimasRefresh: 0,
      showInformavimas: false,
      asmenys: [],
      salys: [],
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      showFail: false,
      failMsg: null,
    }
  },
  computed: {
    ...mapGetters(['prasymasID']),
    headers() {
      return [
        // {
        //   text: 'Asmens kodas',
        //   align: 'start',
        //   value: 'asm_asmens_kodas',
        //   width: 150,
        // },
        {
          text: 'Vardas Pavardė / Pavadinimas',
          align: 'start',
          value: 'asm_pavadinimas',
        },
        {
          text: 'El. pašto adresas',
          align: 'start',
          value: 'sasm_el_pastai',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.asmenys.map((item, index) => {
        item.canEdit = !this.isReadonlyForm
        item.canView = this.isReadonlyForm
        item.readonly = this.isReadonlyForm

        item.atstovas = {}
        if (item.tipas === 'JUR') {
          item.atstovas = {
            parent_atstovas_id: item.sasm_id,
            sasm_id: item.atstovas_sasm_id,
            asm_pavadinimas: item.atstovas_pavadinimas,
            sasm_role_objekte: 'atstovas',
          }
        }

        item.isAtstovas = item.atstovas_sasm_id

        item.atstovas_veikiantis_nowrap = ''
        if (item.atstovas_veikiantis) {
          item.atstovas_veikiantis_nowrap = `<span class="nowrap">${item.atstovas_veikiantis.replaceAll(
            ',',
            ',</span> <span class="nowrap">'
          )}</span>`
        }
        if (this.isPrasymasPirmenybe) {
          item.atstovas_veikiantis_nowrap = item.atstovas_veikiantis
        }
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isReadonly() {
      return this.readonly
    },
    isReadonlyForm() {
      return this.readonly
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/informuojami`)
        .then(res => {
          this.asmenys = res.data.asmenys
          this.updateErrors()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    editItem(item) {
      this.openInformavimas(item)
    },
    openInformavimas(item) {
      this.modalInformavimasKey =
        'informavimas' + this.modalInformavimasRefresh++
      this.modalInformavimasReadonly = item && !item.canEdit
      this.modalInformavimasItem = item
        ? JSON.parse(JSON.stringify(item))
        : { asm_pavadinimas: '', sasm_el_pastai: [''] }
      this.showInformavimas = true
    },
    confirmInformavimas() {
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.duomenys {
  padding-top: 10px;
  padding-bottom: 10px;

  p {
    padding: 3px 0px;
    margin: 0;
  }

  dl {
    display: flex;
    flex-flow: row wrap;
  }
  dt {
    flex-basis: 40%;
    padding: 2px 4px;
    text-align: right;
    font-weight: 400;
  }
  dd {
    flex-basis: 40%;
    flex-grow: 1;
    margin: 0;
    padding: 2px 4px;
    font-weight: 600;
  }
}
</style>
